<div class="alerts-container">
    <div class="d-flex">
        <div class="d-flex flex-column alerts-filters-container">
            <div class="alerts-filters-container">
                <span>Filter:</span>
                <span (click)="alterManagedFilter(undefined)" (keydown)="alterManagedFilter(undefined)" class="alerts-filter"
                    [ngClass]="{'active': filters.managed == undefined}">Show all</span>
                <span (click)="alterManagedFilter(true)" (keydown)="alterManagedFilter(true)" class="alerts-filter"
                    [ngClass]="{'active': !!filters.managed}">Show managed alerts</span>
                <span (click)="alterManagedFilter(false)" (keydown)="alterManagedFilter(false)" class="alerts-filter me-4"
                    [ngClass]="{'active': filters.managed == false}">Show no managed alerts</span>
            </div>
            <div class="alerts-filters-container">
                <span>Date:</span>
                <span (click)="alterAlltimeDateFilter()" (keydown)="alterAlltimeDateFilter()" class="alerts-filter"
                    [ngClass]="{'active': !!filters.dateAllTime}">All time</span>
                <span (click)="alterMonthDateFilter()" (keydown)="alterMonthDateFilter()" class="alerts-filter"
                    [ngClass]="{'active': !!filters.dateThisMonth}">This month</span>
                <span (click)="alterYearDateFilter()" (keydown)="alterYearDateFilter()" class="alerts-filter"
                    [ngClass]="{'active': !!filters.dateThisYear}">This year</span>
            </div>
        </div>
        <app-paginator #alertsPaginator (pageChange)="loadAlerts()"></app-paginator>
    </div>
    <div class="alerts-table">
        <div (click)="viewAlertFeatures(alert)" (keydown)="viewAlertFeatures(alert)" class="alerts-row" *ngFor="let alert of alerts">
            <div class="form-field-header alert-id">
                <span>#{{alert.id}}</span>
                <ng-container [ngSwitch]="utils.getStatus(alert)">
                    <span *ngSwitchCase="cyberAttackManagementStatus.Done" class="alert-badge managed">Done</span>
                    <span *ngSwitchCase="cyberAttackManagementStatus.NeedAction" class="alert-badge need-action">Need
                        action</span>
                    <span *ngSwitchCase="cyberAttackManagementStatus.Pending" class="alert-badge pending">Pending</span>
                </ng-container>
            </div>
            <div class="alert-data">
                <div class="alert-tile">
                    <span class="title">Alert node</span>
                    <span class="data">{{alert.node.name}}</span>
                </div>
                <div class="alert-tile">
                    <span class="title">Detection date</span>
                    <span class="data">{{alert.date | date: 'dd-MM-yyyy HH:mm'}}</span>
                </div>
            </div>
        </div>
    </div>
</div>
